import { render, staticRenderFns } from "./SelectForm.vue?vue&type=template&id=2e203268"
import script from "./SelectForm.vue?vue&type=script&lang=js"
export * from "./SelectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports